// @ts-ignore
import App from './App.svelte';

const app = new App({
	target: document.getElementById('divBurglaryCheck'),
	name: 'Inbraakcheck',
	props: {
		name: 'Inbraakcheck',
		defaultMapCenter: { lat: 52.10, lng: 5.65 },
		defaultMapZoom: 7
	}
});

export default App;